import { SpinLoader } from 'app/components';
import * as React from 'react';
import { useEffect } from 'react';
import { useActionCreators } from 'app/area/favourite/hooks';

interface CreateCompanyReportFavouriteRouteProps {
  router: { location: { query: { report: string }}};
  params: {
    favouriteId: number;
  };
}

export function CreateCompanyReportFavouriteRoute({
  params
}: CreateCompanyReportFavouriteRouteProps) {

  const {
    loadCompanyReportFavouriteDefinition
  } = useActionCreators();

  useEffect(() => {
    const createDraft = () => {
      loadCompanyReportFavouriteDefinition(params);
    };
    createDraft();
  }, []);

  return <SpinLoader />;
}
